export default __webpack_public_path__ + "static/media/caret_dx.2452b64f.svg";